import { Injectable } from "@angular/core";
import { Token } from "app/auth/dto/token.dto";
import { StorageService } from "app/service/storage.service";

@Injectable({
  providedIn: 'root'
})
export class SeguridadUtils {

  constructor(private storageService: StorageService) { }

  hasFunction(funcion: string) {
    let hasFunction = false;
    const token = JSON.parse(this.storageService.getItem('user')) as Token;
    if (token && token.funciones && token.funciones.length !== 0) {
      const funcionEncontrada = token.funciones.filter(f => funcion === f.nombre)[0];
      if (funcionEncontrada) {
        hasFunction = true;
      }
    }
    return hasFunction;
  }
  
  hasNotFunction(funcion: string) {
    return !this.hasFunction(funcion);
  }

  hasAnyFunction(funciones: string[]) {
    let hasAnyFunction = false;

    funciones.forEach(funcion => {
      if (this.hasFunction(funcion)) {
        hasAnyFunction = true;
      }
    });
    return hasAnyFunction;
  }
}
